import React from 'react'
import AdmBookBarcode from '../../components/AdminTabs/AdminBookBarcode/AdmBookBarcode'

const BookBarcode = () => {
  return (
    <div>
      <AdmBookBarcode/>
    </div>
  )
}

export default BookBarcode;
